import { ProductCategoryKeys } from '../../../../common/enums/common';
import {
  Tags,
  CheckInStoreOnlyAvailability,
  CheckIncompatibleRxTagAvailability,
  checkNewTagAvailability,
} from '../../../../container/glasses/frames/rules/egFrameRules';
import { IProductVariant } from '../../../../services/helper/productInterfaces';

export const useProductTags = (
  variants: IProductVariant[],
  type = ProductCategoryKeys.EYEGLASS_FRAMES,
) => {
  // Should be single source for generating product tags
  const getProductTags = (variant: any) => {
    const items: Array<string> = [];
    // handling tags for Contact lenses
    if (type === ProductCategoryKeys.CONTACT_LENSES) return items;

    // Handle tags for rest of application
    // TODO: Add tag generation for any other scenarios if required
    if (CheckInStoreOnlyAvailability(variant)) {
      items.push(Tags.INSTORE);
    } else {
      if (checkNewTagAvailability(variant?.releaseDate as string, type)) {
        items.push(Tags.NEW);
      }
      if
        (CheckIncompatibleRxTagAvailability(variant)) {
        items.push(Tags.INCOMPATIBLE);
      }
    }
    return items;
  };

  return {
    getProductTags,
  };
};
